// src/router/guards/AuthGuard.tsx
// Route guard — redirects unauthenticated users to /login.
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/app/hooks'
import { RingLoader } from 'react-spinners'

export default function AuthGuard() {
  const { isAuthenticated, isInitializing } = useAuth()

  if (isInitializing) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-neutral-50 dark:bg-[#06090d] transition-colors duration-150">
        <RingLoader color="#33cb98" size={80} />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}

